export class Types {
  constructor() {
    this._pathBase = 0;
    this.Selection = 1;
    this.InputCana = 2;
    this.Input = 3;
    this.Current = 4;
    this.Circle = 5;
    this.Line = 6;
    this.Connection = 7;
    this.Area = 8;
    this.Box = 9;
    this.Text = 10;
    this.Triangle = 11;
    this.OnOff = 12;
    this.Tanque = 13;
    this.Occupation = 14;
    this.Milling = 15;
    this.Boiler = 16;
    this.ContinuousDorna = 17;
    this.FermentationBatch = 18;
    this.CargoLoss = 19;
    this.DistillationColumnA = 20;
    this.DistillationColumnB = 21;
    this.Vat = 22;
    this.EthanolCentrifuge = 23;
    this.Desuperheater = 24;
    this.DilutionTank = 25;
    this.Flotador = 26;
    this.Deaerator = 27;
    this.EnergyDemand = 28;
    this.Turbine = 29;
    this.TowerCO2 = 30;
    this.Filter3 = 31;
    this.RegeneratorD = 32;
    this.ProductionChange = 33;
    this.SugarCooker = 34;
    this.CoolingTower = 35;
    this.Evaporator = 36;
    this.CaneCleaning = 37;
    this.Decanter = 38;
    this.Diffuser = 39;
    this.Crystallizer = 40;
    this.SprayDryer = 41;
    this.CombustionReactor = 42;
    this.Evaporator2 = 43;
    this.MultipleInput = 44;
    this.Bomb = 45;
    this.EvaporativeCondenser = 46;
    this.SugarCentrifugue = 47;
    this.Heater = 48;
    this.Liming = 49;
    this.DistillationColumn2 = 50;
    this.Dryer = 51;
    this.Flash = 52;    
    this.SugarCookerContinuous = 53;    
    this.Arrow = 54;
    this.Strainer = 55;
    this.SulphitationTower = 56;
    this.ProductionChangeEditable = 57;
    this.AreaJoker = 58;
    this.FilterPress = 59;
    this.Valve = 60;
    this.Condenser = 61;
    this.SugarCentrifugueBatch = 62;
    this.ConcentratorYeast = 63;
    this.Finisher = 64;
    this.Washer = 65;
    this.CentrifugeCitrus = 66;
    this.CellFactory = 67;
    this.EvaporationCitrus = 68;
    this.ExtractorCitrus = 69;
    this.Rectangle = 70;
    this.Ultrafiltro = 71;
    this.Pasteurization = 72;
    this.CycloneAndScrubber = 73;
    this.Scrubber = 74;
    this.InputCorn = 75;
    this.Clarifer = 76;
    this.CornCooker = 77;
    this.CornDecanter = 78;
    this.CornLiquefacao = 79;
    this.CornMZSA = 80;
    this.CornDDGS = 81;                
    this.CornMill = 82;                
    this.Citrus = 83;                

    /*
      DEIXAR AQUI AS CHAVES DA INTERNACIONALIZAÇÃO 
      E COLOCAR O NOME DO OBJETO NO ARQUIVO DA INTERNACIONALIZAÇÃO
    */

    this.Caption = [
      "base",
      "selecao",
      "propriedades-da-cana",
      "manipulable-value",
      "current",
      "circulo",
      "line",
      "conexao",
      "area",
      "caixa",
      "text",
      "triangle",
      "Liga/Desliga",
      "tanque",
      "occupation",
      "moenda",
      "boiler",
      "dorna-continua",
      "fermentacao-batelada",
      "perda-de-carga",
      "coluna-destilacao-a",
      "aparelho-de-destilacao",
      "cuba",
      "centrif-etanol",
      "dessuperaquecedor",
      "tanque-de-diluicao",
      "flotador",
      "desaerador",
      "demanda-de-energia",
      "turbina",
      "co2Tower",
      "filtro-rotativo",
      "regenerador",
      "ProductionChange",
      "cozedor",
      "torre-de-resfriamento",
      "evaporador",
      "limpeza-de-cana",
      "decantador",
      "difusor",
      "cristalizador",
      "spray-dryer",
      "reator-de-combustao",
      "evaporador-2",
      "multipleManipulatingValues",
      "bomb",
      "condensador-evaporativo",
      "centrif-acucar-cont",
      "heater",
      "liming",
      "coluna-destilacao-2",
      "secador",
      "flash-1",
      "cozedor-continuo",
      "arrow",
      "peneira",
      "torre-de-sulfitacao",
      "setar-valores-multiplos",
      "area-coringa",
      "filtro-prensa",
      "valvula",
      "condensador",
      "centrif-acucar-bat",
      "concentrador-de-levedura",
      "finisher",
      "lavadora",
      "centrifuga-citrus",
      "cellsFactoryArea",
      "evaporationArea",
      "extratora",
      "rectangle",
      "ultrafilter",
      "pasteurization",
      "ciclone-e-lavador-de-gases",
      "scrubber",
      "input-corn",
      "clarifer",
      "cornCooker" ,
      "cornDecanter" ,
      "cornLiquefacao" ,
      "cornMZSA",
      "cornDDGS",
      "cornMill",
      "Citrus"
    ];

    this.inputNodes = [
      this.Input,
      this.InputCana,
      this.OnOff,
      this.Milling,
      this.Boiler,
      this.ContinuousDorna,
      this.FermentationBatch,
      this.DistillationColumnA,
      this.DistillationColumnB,
      this.CargoLoss,
      this.Vat,
      this.EthanolCentrifuge,
      this.Desuperheater,
      this.DilutionTank,
      this.Flotador,
      this.Deaerator,
      this.EnergyDemand,
      this.Turbine,
      this.TowerCO2,
      this.Filter3,
      this.RegeneratorD,
      this.ProductionChange,
      this.SugarCooker,
      this.CoolingTower,
      this.Evaporator,
      this.CaneCleaning,
      this.Decanter,
      this.Diffuser,
      this.Crystallizer,
      this.SprayDryer,
      this.CombustionReactor,
      this.Evaporator2,
      this.MultipleInput,
      this.Bomb,
      this.EvaporativeCondenser,
      this.SugarCentrifugue,
      this.Heater,
      this.Liming,
      this.DistillationColumn2,
      this.Dryer,
      this.SugarCookerContinuous,
      this.Strainer,
      this.SulphitationTower,
      this.ProductionChangeEditable,
      this.FilterPress,
      this.Valve,
      this.Condenser,
      this.SugarCentrifugueBatch,
      this.ConcentratorYeast,
      this.Finisher,
      this.Washer,
      this.CentrifugeCitrus,
      this.CellFactory,
      this.EvaporationCitrus,
      this.ExtractorCitrus,
      this.InputCorn,
      this.Citrus
    ];
  }
}
